import * as Yup from 'yup';
import { ValidationError } from 'yup';
import * as Errors from './errors';
import { LinkableErrorMessageProps } from '@mo/page-error-box/dist/PageErrorBox';

type ErrorType = { [path: string]: string[] };

export type LoginData = {
    username?: string;
    password?: string;
};

const mapSchemaErrors = (e: ValidationError): ErrorType =>
    e.inner.reduce((errors: ErrorType, error: ValidationError): ErrorType => {
        if (error.path === undefined) {
            return errors;
        }
        const message = errors[error.path] || [];
        return {
            ...errors,
            [error.path]: message.concat(error.message),
        };
    }, {});

const validationSchema = Yup.object()
    .shape({
        password: Yup.string().nullable(true).required(Errors.BLANK_PASSWORD),
    })
    .defined();

export const validate = (data: LoginData): Promise<LoginData> => {
    return validationSchema.validate(data, { abortEarly: false }).catch(
        (e: ValidationError): LoginData => {
            throw mapSchemaErrors(e);
        }
    );
};

export const mapPageValidationErrors = (validationErrors: { [key: string]: string[] }): LinkableErrorMessageProps[] => {
    const usernameErrors = validationErrors.username
        ? validationErrors.username.map((error): LinkableErrorMessageProps => ({ label: 'Username', message: error }))
        : [];

    const passwordErrors = validationErrors.password
        ? validationErrors.password.map((error): LinkableErrorMessageProps => ({ label: 'Password', message: error }))
        : [];

    return usernameErrors.concat(passwordErrors);
};
